export default __webpack_public_path__ + "static/media/responsivex2.4ceafa00.png";